
import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";
import FetchService from "@/core/services/fetch.service";

export const LOGIN_ERP = "LOGIN_ERP";
export const LOGOUT_ERP = "LOGOUT_ERP";
export const SET_USER_DATA = "set_user_data";
export const PURGE_AUTH = "PURGE_AUTH";

const state = {
  user_data: localStorage.getItem('user_data') != 'undefined' ? JSON.parse(localStorage.getItem('user_data')) : "",
  isAuthenticated_2: localStorage.getItem('user_data') != 'undefined' ? true : false
};

const getters = {
  showUserData: (state, getters, rootState) => {
    return state.user_data
  },
  isAuthenticated_2(state) {
    return state.isAuthenticated_2;
  }
};

const actions = {
  [LOGIN_ERP](context, state) {
    return new Promise(resolve => {
      let user = state.username
      let pass = state.password
      var raw = JSON.stringify({
        "username": user,
        "password": pass
      });

      FetchService.postUser("/users/login", raw, res => {
        let user_data = JSON.parse(res)
        if (user_data?.user) {
          context.commit(SET_USER_DATA, JSON.stringify(user_data.user));
          resolve([user_data.user]);
        } else {
          alert(user_data?.msg_BtoF)
          resolve([]);
        }
      })
    });
  },
  [LOGOUT_ERP](context) {
    context.commit(PURGE_AUTH);
  },
};

const mutations = {
  [SET_USER_DATA](state, payload) {
    // console.log("payload", payload);
    localStorage.setItem('user_data', payload)
    state.isAuthenticated_2 = true;
    state.user_data = payload
  },
  [PURGE_AUTH](state) {
    state.isAuthenticated_2 = false;
    state.user = {};
    state.errors = {};
    JwtService.destroyToken();
    console.log('logout')
    localStorage.removeItem('user_data')
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
